// extracted by mini-css-extract-plugin
export default {"docViewer":"DocumentViewer-module__docViewer--qs3Wq"};